import React, { type FC } from 'react'

import { Translation } from '../../../../domain'

import { TextField } from '../../common'
import { useTranslator } from '../../Internationalization'
import { useAppUsecase } from '../../State'

export const TopicsInput: FC = () => {
    const translator = useTranslator()
    const filter = useAppUsecase('filterSandboxUsecase')

    return (
        <TextField
            data-testid="rule-engine-topics-input"
            fullWidth
            placeholder={translator.formatTranslation(Translation.TOPIC_PLACEHOLDER)}
            onChange={({ target }) => filter.selectTopics(target.value ? [target.value] : [])}
        />
    )
}
